import React from "react";

interface OwnProps {
    fill?: string;
}

type Props = OwnProps;

export const ArrowRight = (props: Props) => {
    const { fill = "#646363" } = props;
    return (
        <svg
            width="33"
            height="16"
            viewBox="0 0 33 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M31.7106 8.70315C32.0989 8.31046 32.0954 7.6773 31.7027 7.28896L25.3035 0.960444C24.9108 0.572095 24.2776 0.575612 23.8893 0.9683C23.501 1.36099 23.5045 1.99414 23.8972 2.38249L29.5853 8.00784L23.96 13.696C23.5717 14.0887 23.5752 14.7219 23.9679 15.1102C24.3605 15.4986 24.9937 15.495 25.3821 15.1024L31.7106 8.70315ZM1.00555 9.16661L31.0051 8.99996L30.994 6.99999L0.994445 7.16664L1.00555 9.16661Z"
                fill={fill}
            />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/views/documentation/components/ArrowRight.tsx